<template>
  <div style="width: 100%; cursor: pointer">
    <div class="vtl">
      <div v-if="model.name !== 'root'" :class="isTextDisabled">
        <div
          v-if="filterMatched"
          :id="model.id"
          :class="treeNodeClass"
          @click.stop="click"
        >
          <b-col :style="{ 'padding-left': 30 * level + 'px' }" cols="8">
            <div class="vtl-node-content" :class="isTextDisabled">
              <span
                v-if="model.children && model.children.length > 0"
                class="vtl-caret vtl-is-small"
              >
                <i
                  class="vtl-icon"
                  :class="caretClass"
                  @click.prevent.stop="toggle"
                />
              </span>
              <b :class="isTextDisabled">{{
                model.evaluation_administrator_node_nomenclature
              }}</b>
              <span v-if="level <= 2" :class="isNotParent">
                <b :class="isTextDisabled">
                  {{ model.evaluation_administrator_node_requirementName }}
                </b>
              </span>
              <span v-else :class="isNotParent">
                <span :class="isTextDisabled">
                  {{
                    model.evaluation_administrator_node_requirementName
                  }}</span
                >
              </span>
            </div>
          </b-col>
          <b-col
            v-if="(!hasChildren() && areEvidencesRequired()) || !expanded"
            cols="1"
          >
            <div
              v-if="hasChildren()"
              style="text-align: center"
              :class="
                getStatus(
                  getEvidenceStatusFromScore(model.evidencesStatusScore)
                )
              "
            >
              {{ $t(getEvidenceStatusFromScore(model.evidencesStatusScore)) }}
            </div>
            <div
              v-if="!hasChildren()"
              style="text-align: center"
              :class="
                getStatus(
                  model.evaluation_administrator_node_editRequirement_evidencesReady ||
                    'label_evaluation_evidencesRequested_status_pending'
                )
              "
            >
              {{
                $t(
                  model.evaluation_administrator_node_editRequirement_evidencesReady ||
                    "label_evaluation_evidencesRequested_status_pending"
                )
              }}
            </div>
          </b-col>
          <b-col
            v-if="(!hasChildren() && areEvidencesRequired()) || !expanded"
            cols="1"
          >
            <div
              :class="isTextDisabled"
              style="
                text-align: center;
                margin-left: -5px;
                display: flex;
                justify-content: center;
                gap: 5px;
              "
            >
              <div>{{ model.totalEvidences }}</div>
              <div :class="getEvidenceIndicatorsColors()" />
            </div>
          </b-col>
          <b-col
            v-if="(!hasChildren() && areEvidencesRequired()) || !expanded"
            cols="2"
          >
            <div :class="isTextDisabled" style="text-align: center">
              {{ model.evaluation_last_updated }}
            </div>
          </b-col>
          <b-row
            v-if="!hasChildren() && areEvidencesRequired()"
            :style="{ 'padding-left': 30 * level + 'px' }"
            class="evidence-note"
          >
            <span :class="isTextDisabled">{{
              $t(getEvidenceIndicatorsText())
            }}</span>
          </b-row>
        </div>
      </div>
      <div v-show="model.name === 'root' || expanded" v-if="isFolder">
        <evaluation-organization-tree-list
          v-for="model in model.children"
          :key="model.id"
          :default-tree-node-name="defaultTreeNodeName"
          :default-leaf-node-name="defaultLeafNodeName"
          :default-expanded="defaultExpanded"
          :model="model"
          :is-submitted="isSubmitted"
          :account="account"
          :evaluation-id="evaluationId"
          :level="level + 1"
          :filter="filter"
          style="margin-top: 5px"
          @notifyMatching="notifyMatching"
        />
      </div>
      <b-modal
        id="modalInfo"
        v-model="showModal"
        modal-class="modalInfo"
        :title="'Delete '"
      >
        {{ $t("label_evaluation_delete_message") }}
        <b> {{ model.evaluation_administrator_node_requirementName }}</b>
        <div slot="modal-footer" class="w-100" style="text-align: right">
          <b-btn variant="primary" @click="hideModal()">
            {{ $t("label_evaluation_cancel_button") }}
          </b-btn>
          <b-btn variant="primary" @click="delNode()">
            {{ $t("label_evaluation_create_button") }}
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script >
import {
  addHandler,
  removeHandler,
} from "../../../../utils/vue-tree-list/tools";
import axios from "axios";

export default {
  name: "EvaluationOrganizationTreeList",
  props: {
    account: {
      type: Object,
      default: () => {},
    },
    model: {},
    defaultLeafNodeName: {
      type: String,
      default: "New leaf node",
    },
    defaultTreeNodeName: {
      type: String,
      default: "New tree node",
    },
    defaultExpanded: {
      type: Boolean,
      default: true,
    },
    evaluationId: {
      type: String,
      default: "0",
    },
    level: {
      type: Number,
      default: 0,
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      isHover: false,
      editable: false,
      expanded: this.defaultExpanded,
      showModal: false,
      totalEvidences: 0,
      isDisabled: false,
      filterMatched: true,
      filteredChildren: 0,
      evidencesScore: -1,
      count: 0,
      labels: {
        0: "label_evaluation_not achieved",
        50: "label_evaluation_partially achieved",
        75: "label_evaluation_close to be achieved",
        100: "label_evaluation_achieved",
      },
    };
  },
  computed: {
    itemIconClass() {
      return this.model.isLeaf ? "vtl-icon-file" : "vtl-icon-folder";
    },
    caretClass() {
      return this.expanded ? "vtl-icon-caret-down" : "vtl-icon-caret-right";
    },
    isFolder() {
      return this.model.children && this.model.children.length;
    },

    isNotParent() {
      return typeof this.model.children === "undefined"
        ? "selectable underlined"
        : "";
    },

    isTextDisabled() {
      return this.isDisabled || this.isSubmitted ? "disabled" : "";
    },

    treeNodeClass() {
      const {
        model: { dragDisabled, disabled },
        isDragEnterNode,
      } = this;

      return {
        "vtl-tree-node": true,
        "vtl-active": isDragEnterNode,
        "vtl-drag-disabled": dragDisabled,
        "vtl-disabled": disabled,
        "hover-activated":
          !this.model.children || this.model.children.length === 0,
      };
    },
  },
  watch: {
    filter: function () {
      this.count = 0;
      this.filteredChildren = 0;
      if (!this.model.children) {
        if (
          this.filter ===
            (this.model
              .evaluation_administrator_node_editRequirement_evidencesReady ||
              "label_evaluation_evidencesRequested_status_pending") ||
          this.filter === ""
        ) {
          this.filterMatched = true;
          this.$emit("notifyMatching", 1);
        } else {
          this.filterMatched = false;
          this.$emit("notifyMatching", 0);
        }
      }
    },
  },
  mounted() {
    const vm = this;
    if (this.model.submitted == true) {
      this.isDisabled = true;
    }
    addHandler(window, "keyup", function (e) {
      // click enter
      if (e.keyCode === 13 && vm.editable) {
        vm.editable = false;
      }
    });
  },
  beforeDestroy() {
    removeHandler(window, "keyup");
  },
  methods: {
    getEvidenceStatusFromScore(score) {
      switch (score) {
        case 5:
          return "label_evaluation_evidencesRequested_status_submitted";
        case 4:
          return "label_evaluation_evidencesRequested_status_ready";
        case 3:
          return "label_evaluation_evidencesRequested_status_pending";
        case 2:
          return "label_evaluation_evidencesRequested_status_inProgress";
        case 1:
          return "label_evaluation_evidencesRequested_status_resubmit";
        case 0:
          return "label_evaluation_evidencesRequested_status_pending";
      }
    },
    areEvidencesRequired() {
      return this.model
        .evaluation_administrator_node_editRequirement_requireEvidences;
    },
    hasChildren() {
      return this.model.children && this.model.children.length > 0;
    },
    notifyMatching(num) {
      if (this.model.children) {
        this.count++;
        this.filteredChildren += num;
        if (this.count == this.model.children.length) {
          if (this.filteredChildren > 0) {
            this.filterMatched = true;
            this.$emit("notifyMatching", 1);
          } else {
            this.filterMatched = false;
            this.$emit("notifyMatching", 0);
          }
        }
      }
    },
    getStatus(status) {
      if (this.isDisabled || this.isSubmitted) {
        return "statusTag disabled";
      }
      switch (status) {
        case "label_evaluation_evidencesRequested_status_ready":
          return "statusTag ready";
        case "label_evaluation_evidencesRequested_status_pending":
          return "statusTag pending";
        case "label_evaluation_evidencesRequested_status_inProgress":
          return "statusTag inProgress";
        case "label_evaluation_evidencesRequested_status_resubmit":
          return "statusTag resubmit";
      }
    },

    getStatusValue(status) {
      switch (status) {
        case "label_evaluation_evidencesRequested_status_ready":
          return {
            label: "label_evaluation_evidencesRequested_status_ready",
            value: 3,
          };
        case "label_evaluation_evidencesRequested_status_pending":
          return {
            label: "label_evaluation_evidencesRequested_status_pending",
            value: 2,
          };
        case "label_evaluation_evidencesRequested_status_inProgress":
          return {
            label: "label_evaluation_evidencesRequested_status_inProgress",
            value: 1,
          };
        case "label_evaluation_evidencesRequested_status_resubmit":
          return {
            label: "label_evaluation_evidencesRequested_status_resubmit",
            value: 0,
          };
        default:
          return { label: "", value: -1 };
      }
    },
    getEvidenceIndicatorsText() {
      switch (this.model.evidencesScore) {
        case 3:
          return "label_evaluation_evidencesRequested_evidenceInfo_file_message";
        case 2:
          return "label_evaluation_evidencesRequested_evidenceInfo_usedInOtherRequirements_message";
        case 1:
          return "label_evaluation_evidencesRequested_evidenceInfo_explanation_message";
        case 0:
          return "label_evaluation_evidencesRequested_evidenceInfo_pending_message";
      }
    },

    getEvidenceIndicatorsColors() {
      switch (this.model.evidencesScore) {
        case 3:
          return "evidences-indicator-green";
        case 2:
          return "evidences-indicator-blue";
        case 1:
          return "evidences-indicator-comment";
        case 0:
          return "evidences-indicator-gray";
        default:
          return {};
      }
    },
    fillProgress() {
      // eslint-disable-next-line camelcase
      if (this.model.children && this.model.children.length > 0) {
        var total = 0;
        this.model.children.map((child) => {
          if (!isNaN(child.evaluation_status)) {
            if (child.children && child.children.length > 0) {
              total = total + parseFloat(child.evaluation_status);
            } else {
              total =
                total +
                (child.evaluation_status *
                  child.evaluation_administrator_node_percentualWeight) /
                  100;
            }
          }
          if (
            total >= this.model.evaluation_administrator_node_percentualWeight
          ) {
            // eslint-disable-next-line camelcase
            this.model.evaluation_status =
              this.model.evaluation_administrator_node_percentualWeight;
          } else {
            // eslint-disable-next-line camelcase
            this.model.evaluation_status = total;
          }
        });

        var totalP = 0;
        this.model.children.map((s) => {
          if (s.children && s.children.length > 0) {
            if (s.evaluation_progress === s.children.length) {
              totalP++;
            }
          } else {
            if (!isNaN(s.evaluation_status)) {
              totalP++;
            }
          }
        });
        // eslint-disable-next-line camelcase
        this.model.evaluation_progress = totalP;
      }
      this.$forceUpdate();
      if (this.$parent.fillProgress) {
        this.$parent.fillProgress();
        this.$parent.$forceUpdate();
      }
    },
    updateLastUpdateAllParents() {
      var node = this.$parent;
      while (node._props.model.name !== "root") {
        // eslint-disable-next-line camelcase
        node.model.evaluation_last_updated = new Date().toLocaleDateString(
          "en-US"
        );
        node = node.$parent;
      }
    },
    showModalF() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    updateName(e) {
      var oldName = this.model.name;
      this.model.changeName(e.target.value);
      var node = this.getRootNode();
      node.$emit("change-name", {
        id: this.model.id,
        oldName: oldName,
        newName: e.target.value,
      });
    },

    delNode() {
      this.model.remove();
    },

    setEditable() {
      var root = this.getRootNode();
      root.$emit("modify-node", this.model, true);
    },

    setUnEditable() {
      this.editable = false;
    },

    toggle() {
      if (this.isFolder) {
        this.expanded = !this.expanded;
      }
    },

    mouseOver() {
      if (this.model.disabled) {
        return;
      }
      this.isHover = true;
    },

    mouseOut() {
      this.isHover = false;
    },

    async click() {
      if (!this.model.children || this.model.children.length === 0) {
        var node = this.getRootNodeAndPath();
        await this.$store.dispatch("getEvaluation", {
          requirementId: this.model.id,
          isOrganization: false,
        });
        node.node.$emit("updatePath", node.path);
      }
    },

    addChild() {
      var root = this.getRootNode();
      this.expanded = true;
      root.$emit("add-node", this.model, false);
    },

    getRootNode() {
      var node = this.$parent;
      while (node._props.model.name !== "root") {
        node = node.$parent;
      }
      return node;
    },
    getRootNodeAndPath() {
      var node = this.$parent;
      var path = [];
      while (node._props.model.name !== "root") {
        path.push({
          name: node._props.model.evaluation_administrator_node_requirementName,
          nom: node._props.model.evaluation_administrator_node_nomenclature,
        });
        node = node.$parent;
      }
      return { node, path };
    },
  },
};
</script>
<style lang="scss" scoped>
h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}
@font-face {
  font-family: "icomoon";
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot");
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot")
      format("embedded-opentype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.ttf") format("truetype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.woff") format("woff"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}

.selectable:hover {
  text-decoration-line: underline;
}
.underlined:hover {
  cursor: pointer;
}

.vtl-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &.vtl-menu-icon {
    margin-right: 4px;
    &:hover {
      color: inherit;
    }
  }
  &:hover {
    color: blue;
  }
}

.statusTag {
  &.ready {
    color: white;
    background-color: #009355;
  }
  &.pending {
    background-color: #cbd2d3;
  }
  &.inProgress {
    background-color: #ffbe00;
  }
  &.resubmit {
    background-color: #86a5dd;
  }
}

.evidence-note {
  color: #007d76;
  padding-left: 10px;
}

.vtl-icon-file:before {
  content: "\e906";
}
.vtl-icon-folder:before {
  content: "\e907";
}
.vtl-icon-caret-down:before {
  content: "\e901";
}
.vtl-icon-caret-right:before {
  content: "\e900";
}
.vtl-icon-edit:before {
  content: "\e902";
}
.vtl-icon-folder-plus-e:before {
  content: "\e903";
}
.vtl-icon-plus:before {
  content: "\e904";
}
.vtl-icon-trash:before {
  content: "\e905";
}

.vtl-border {
  height: 5px;
  &.vtl-up {
    margin-top: -5px;
    background-color: transparent;
  }
  &.vtl-bottom {
    background-color: transparent;
  }
  &.vtl-active {
    border-bottom: 3px dashed blue;
    /*background-color: blue;*/
  }
}
.hover-activated:hover {
  background-color: #f0f0f0;
}
.vtl-tree-node {
  padding: 0 !important;
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  .vtl-input {
    border: none;
    max-width: 150px;
    border-bottom: 1px solid blue;
  }

  &.vtl-active {
    outline: 2px dashed pink;
  }
  .vtl-caret {
    margin-left: -1rem;
  }
  .vtl-operation {
    margin-left: 2rem;
    letter-spacing: 1px;
  }
}

.vtl-item {
  cursor: pointer;
}
.break {
  flex-basis: 100%;
  height: 0;
}

.options {
  font-size: 12px;
  font-style: italic;
  .edit {
    color: #0c3a9b;
  }
}
.evidences-indicator-green,
.evidences-indicator-blue,
.evidences-indicator-gray,
.evidences-indicator-comment {
  padding: 0px;
}

.evidences-indicator-green:after {
  content: "";
  padding: 6px;
  background: #3ece0f;
  position: absolute;
  top: 6px;
  border-radius: 50%;
}

.evidences-indicator-blue:after {
  content: "";
  padding: 6px;
  background: #1581f7;
  position: absolute;
  top: 6px;
  border-radius: 50%;
}

.evidences-indicator-gray:after {
  content: "";
  padding: 6px;
  background: #cbd2d3;
  position: absolute;
  top: 6px;
  border-radius: 50%;
}

.evidences-indicator-comment:after {
  content: "";
  padding: 6px;
  border: 1px solid #1e4380;
  position: absolute;
  top: 6px;
  border-radius: 50%;
}

.evidence-indicator {
  color: #1e4380;
  font-style: italic;
}

.disabled {
  color: #b9babd;
}
</style>
